const copy = {
  buttonValue: "View More",
  result: {
    recommendedBadge: "Recommended",
  },
  feedback: {
    prompt: "Did this answer your question?",
    negativeTitle: "Thumbs down - negative feedback",
    positiveTitle: "Thumbs up - positive feedback",
    thankYou: "Thanks for your feedback!",
  },
};

export default copy;
